import React from "react";
import "../FirstPost/FirstPost.css";

const FirstPost = () => {
  return (
    <section className="full-first">
      <div className="firstpost-wrapper-pp">
        <img
          src="/p1.jpg"
          alt="Poster"
          className="poster-imageh"
          loading="lazy"
        />
        <div className="overlay-pp"></div>
        <div className="content-pp">
          <div className="left-pp">
            <p className="tagline-pp">CONCERTS - WEDDING - CORPORATE</p>
            <div className="shine-line-pp"></div>
            <h1 className="heading-pp">
              CREATIVE
              <br />
              AGENCY
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FirstPost;
